// extracted by mini-css-extract-plugin
export default {"card":"W5-z"};